'use client'
import { Slider } from '@/core/ui/atoms/slider'
import { Product } from '@/features/product/model/product.model'
import { ProductCard } from '../product-card'
import { use } from 'react'
import { useLocale } from 'next-intl'

interface Props {
  products: Product[] | Promise<Product[]>
  slidesPerView?: number
  breakpoints?: { [width: number]: number }
  showArrows?: boolean
}
export function ProductList({
  products,
  slidesPerView,
  breakpoints,
  showArrows,
}: Props) {
  const productsList = products instanceof Promise ? use(products) : products
  const locale = useLocale()
  const isRTL = locale === 'ar'
  return (
    <Slider
      slides={productsList.map(product => (
        <ProductCard {...product} key={product.id} />
      ))}
      slidesPerView={slidesPerView ?? 1}
      showDots={false}
      showArrows={showArrows ?? true}
      delay={4000}
      autoPlay
      className='sm:px-5'
      breakpoints={
        breakpoints || {
          340: 1.3,
          400: 1.6,
          640: 2,
          768: 3,
          1024: 4,
          1280: 5,
          1536: 6,
          1920: 7,
        }
      }
      renderPrevArrow={scrollPrev => (
        <button
          onClick={scrollPrev}
          className='bg-cyan-blue absolute top-1/2 -left-10 z-10 hidden h-8 w-8 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full text-lg text-white shadow-md sm:flex'
        >
          {isRTL ? '›' : '‹'}
        </button>
      )}
      renderNextArrow={scrollNext => (
        <button
          onClick={scrollNext}
          className='bg-cyan-blue absolute top-1/2 -right-10 z-10 hidden h-8 w-8 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full text-lg text-white shadow-md sm:flex'
        >
          {isRTL ? '‹' : '›'}
        </button>
      )}
      renderDot={({ index, isActive, onClick }) => (
        <button
          key={index}
          onClick={onClick}
          className={`h-3 w-3 cursor-pointer rounded-full transition-all ${
            isActive
              ? 'bg-creamed-cron'
              : 'bg-anti-flash border-creamed-cron border'
          }`}
        />
      )}
    />
  )
}
